import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import styles from './RegistrationContainer.scss';
import REGISTRATION_FIELDS from './constants';

class RegistrationAgentAdditionalFields extends React.Component {
  render() {
    const { translate, renderInput, locale, uploadWidget } = this.props;
    return (
      <div className={styles.realtorBlock}>
        <div>
          <div className={styles.columnBlock}>
            <div className={styles.title}>
              {translate('authenticationPage', 'companyName')}
            </div>
            <Field
              name={REGISTRATION_FIELDS.COMPANY_NAME}
              type="text"
              component={renderInput}
              placeholder={translate(
                'authenticationPage',
                'companyName'
              )}
            />
          </div>
          <div className={styles.columnBlock}>
            <div className={styles.title}>
              {translate('authenticationPage', 'licenseNumber')}
            </div>
            <Field
              name={REGISTRATION_FIELDS.LICENSE_NUMBER}
              type="text"
              component={renderInput}
              placeholder={translate(
                'authenticationPage',
                'licenseNumber'
              )}
            />
          </div>
          {/* {this.state.isShowCoupon && (
                  <div className={styles.columnBlock}>
                    <div className={styles.title}>
                      {translate('authenticationPage', 'coupon')}
                    </div>
                    <Field
                      name={REGISTRATION_FIELDS.COUPON}
                      type="text"
                      component={this.renderInput}
                      placeholder={this.props.translate('authenticationPage', 'coupon')}
                    />
                  </div>
                )} */}
        </div>
        <div>
          <div className={styles.columnBlock}>
            <div className={styles.title}>
              {translate('authenticationPage', 'logo')}
            </div>
            <Field
              name={REGISTRATION_FIELDS.LOGO}
              locale={locale}
              component={uploadWidget}
            />
          </div>
        </div>
      </div>
    );
  }
}

RegistrationAgentAdditionalFields.propTypes = {
  translate: PropTypes.func,
  renderInput: PropTypes.func,
  uploadWidget: PropTypes.func,
  locale: PropTypes.string
};

export default RegistrationAgentAdditionalFields;
